import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NSAutocompleteModule, NSGridModule } from '@norfolk-southern/accessns-components';

import { RateActionsComponent } from '@ruby/modules/rate-inquiry/components/rate-actions/rate-actions.component';
import { RateFormComponent } from '@ruby/modules/rate-inquiry/components/rate-form/rate-form.component';
import { RateListComponent } from '@ruby/modules/rate-inquiry/components/rate-list/rate-list.component';
import { RateNotesComponent } from '@ruby/modules/rate-inquiry/components/rate-notes/rate-notes.component';
import { RateResultsComponent } from '@ruby/modules/rate-inquiry/components/rate-results/rate-results.component';
import { RateActionsContainerComponent } from '@ruby/modules/rate-inquiry/containers/rate-actions/rate-actions.container';
import { RateFormContainerComponent } from '@ruby/modules/rate-inquiry/containers/rate-form/rate-form.container';
import { RateListContainerComponent } from '@ruby/modules/rate-inquiry/containers/rate-list/rate-list.container';
import { RateResultsContainerComponent } from '@ruby/modules/rate-inquiry/containers/rate-results/rate-results.container';
import { RateContainerComponent } from '@ruby/modules/rate-inquiry/containers/rate.container';
import { RateInquiryRoutingModule } from '@ruby/modules/rate-inquiry/rate-inquiry-routing.module';
import * as fromRate from '@ruby/modules/rate-inquiry/store';
import { effects } from '@ruby/modules/rate-inquiry/store/effects';
import { EmailDialogModule } from '@ruby/shared/dialogs/email/email.module';
import { RateNotesDialogModule } from '@ruby/shared/dialogs/rate-notes/rate-notes.dialog.module';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';
import { FavoritesModule } from '@ruby/shared/favorites/favorites.module';
import { GridPreferencesCustomService } from '@ruby/shared/services/grid-preferences-custom.service';

@NgModule({
  declarations: [
    RateActionsComponent,
    RateActionsContainerComponent,
    RateContainerComponent,
    RateFormContainerComponent,
    RateFormComponent,
    RateListContainerComponent,
    RateListComponent,
    RateResultsContainerComponent,
    RateResultsComponent,
    RateNotesComponent
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    EffectsModule.forFeature(effects),
    MatButtonModule,
    MatCheckboxModule,
    MatDividerModule,
    MatExpansionModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule,
    NSAutocompleteModule,
    NSGridModule.forRoot(GridPreferencesCustomService),
    ReactiveFormsModule,
    RateInquiryRoutingModule,
    EmailDialogModule,
    RateNotesDialogModule,
    FavoritesModule,
    StoreModule.forFeature(fromRate.featureKey, fromRate.reducers)
  ],
  exports: [RateContainerComponent]
})
export class RateInquiryModule {}
